export const fmt = (v, d = 2) =>
  typeof v === "number" ? v.toLocaleString("en-IN", { minimumFractionDigits: d, maximumFractionDigits: d }) : v ?? "—";

export const compact = (v) =>
  typeof v === "number" ? Intl.NumberFormat("en-IN", { notation: "compact", maximumFractionDigits: 1 }).format(v) : "—";

export const scoreColor = (s) => (s >= 65 ? "#00FF66" : s <= 35 ? "#FF3366" : "#FFCC00");

export const actionTone = (action = "") => {
  const a = action.toUpperCase();
  if (a.includes("WAIT") || a.includes("WATCH") || a.includes("STRANGLE")) return "neutral";
  if (a === "BUY CE" || a === "SELL PE" || a.startsWith("LONG") || a === "BUY" || a.includes("DELIVERY") || a.includes("BTST")) return "bull";
  return "bear";
};

export const toneClasses = {
  bull: "text-[#00FF66] border-[#00FF66]/40 bg-[#00FF66]/10",
  bear: "text-[#FF3366] border-[#FF3366]/40 bg-[#FF3366]/10",
  neutral: "text-[#FFCC00] border-[#FFCC00]/40 bg-[#FFCC00]/10",
};

export const IST_OFFSET = 19800;
